export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-950 text-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-book-open-line text-background-50 text-lg"></i>
              </span>
              <span className="text-xl font-heading font-bold">妖精漫画</span>
            </div>
            <p className="text-sm text-background-300 leading-relaxed">
              妖精漫画网汇集海量韩漫、日漫、国漫，提供各类漫画大全与漫画全集，免费在线观看，下拉式流畅阅读，满足你的全类型漫画需求。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a href="#hero" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#hero" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#hero" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-bilibili-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              {['平台特色', '热门专题', '读者热评', '常见问题', '精选视频', '关于我们'].map((label, i) => (
                <li key={i}>
                  <a href={`#${['features','carousel','comments','faq','media','about'][i]}`} className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer">
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base mb-4">漫画分类</h4>
            <ul className="space-y-2.5">
              {['韩漫推荐', '日漫经典', '国漫精选', '恋爱甜宠', '热血战斗', '悬疑推理'].map((cat, i) => (
                <li key={i}>
                  <a href="#index" className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer">{cat}</a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base mb-4">合作伙伴</h4>
            <p className="text-sm text-background-400 leading-relaxed">
              妖精漫画网与多家国内外漫画平台保持友好合作关系，共同为漫画爱好者提供更丰富的阅读选择。合作联系请通过投稿入口与我们沟通。
            </p>
          </div>
        </div>

        <div className="border-t border-background-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-400">
            &copy; 2026 妖精漫画网 版权所有 | 韩漫日漫国漫大全 | 漫画全集免费在线看
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" className="text-xs text-background-400 hover:text-background-200 transition-colors cursor-pointer">隐私政策</a>
            <a href="#hero" className="text-xs text-background-400 hover:text-background-200 transition-colors cursor-pointer">服务条款</a>
            <a href="#contact" className="text-xs text-background-400 hover:text-background-200 transition-colors cursor-pointer">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}